// extracted by mini-css-extract-plugin
export default {"addSupplierSection":"style_addSupplierSection__OuKif","actionsSection":"style_actionsSection__GwcM4","formSection":"style_formSection__g4svP"};